import { apiErrorCode } from '@/lib/api-error-body'

const TOOL_WORKSPACE_QUERY_PARAM = 'workspaceId'

export function buildToolWorkspaceTargetPath(
  pagePath: string,
  workspaceId: string,
  extraParams: Record<string, string> = {},
): string {
  const [pathname, rawQuery = ''] = pagePath.split('?', 2)
  const params = new URLSearchParams(rawQuery)
  params.set(TOOL_WORKSPACE_QUERY_PARAM, workspaceId)
  for (const [key, value] of Object.entries(extraParams)) {
    params.set(key, value)
  }
  return `${pathname}?${params.toString()}`
}

export function selectedToolWorkspaceFromSearch(
  search: string,
  availableWorkspaceIds: string[],
): string | null {
  const requested = new URLSearchParams(search).get(TOOL_WORKSPACE_QUERY_PARAM)
  return requested && availableWorkspaceIds.includes(requested) ? requested : null
}

export function shouldEnsureToolWorkspace({
  workspaceCount,
  lockedWorkspaceId,
}: {
  workspaceCount: number
  lockedWorkspaceId?: string
}): boolean {
  return workspaceCount === 0 && !lockedWorkspaceId
}

/** Preserve the structured API contract instead of collapsing every 409 into
 * a generic generation failure. Each hook consumes this same classifier. */
export async function isWorkspaceSelectionRequired(
  response: Response,
): Promise<boolean> {
  if (response.status !== 409) return false
  const body: unknown = await response.json().catch(() => null)
  return apiErrorCode(body) === 'workspace_selection_required'
}
